export default __webpack_public_path__ + "static/media/Minus.224d1bfb.svg";